import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

export const countProductsByLabels: Record<
  Constraint_Purchase_Threshold_Counting_Attribute,
  string
> = {
  [Constraint_Purchase_Threshold_Counting_Attribute.Quantity]: 'Product Quantity',
  [Constraint_Purchase_Threshold_Counting_Attribute.MoneyAmount]: 'Money Amount',
  [Constraint_Purchase_Threshold_Counting_Attribute.UnitsCount]: 'Units Count',
};
